import { themeEditorUiConfigCalendar } from "./themeEditorUiConfigCalendar";
import { themeEditorUiConfigClock } from "./themeEditorUiConfigClock";
import { themeEditorUiConfigCountdown } from "./themeEditorUiConfigCountdown";
import { themeEditorUiConfigCountup } from "./themeEditorUiConfigCountup";
import { themeEditorUiConfigMessage } from "./themeEditorUiConfigMessage";

export const themeEditorUiConfig = [
  {
    sectionName: "Global",
    sectionKey: "global",
    description: "Base styles applied across all elements",
    groups: [
      {
        groupName: "Colors",
        elements: [
          {
            label: "Text Color",
            accessAs: "global.color",
            component: "ColorSelector",
            default: "#1a1a1a",
            description: "Default text color for all content",
          },
          {
            label: "Background Color",
            accessAs: "global.background",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Default background color",
          },
        ],
      },
      {
        groupName: "Typography",
        elements: [
          {
            label: "Font Size",
            accessAs: "global.fontSize",
            component: "FontSizeSelector",
            default: "1rem",
            allowCustom: true,
            description: "Base font size for all text",
          },
          {
            label: "Font Weight",
            accessAs: "global.fontWeight",
            component: "FontWeightSelector",
            default: "400",
            description: "Base font weight",
          },
          {
            label: "Font Family",
            accessAs: "global.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Base font family",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Header",
    sectionKey: "header",
    description: "Styling for the top header section",
    groups: [
      {
        groupName: "Colors",
        elements: [
          {
            label: "Text Color",
            accessAs: "header.color",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Header text color",
            options: {
              allowInherit: true,
              modalTitle: "Header Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "header.background",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Header background color",
            options: {
              allowInherit: true,
              modalTitle: "Header Backgound Color",
            },
          },
        ],
      },
      {
        groupName: "Typography",
        elements: [
          {
            label: "Font Size",
            accessAs: "header.fontSize",
            component: "FontSizeSelector",
            default: "2rem",
            allowCustom: true,
            description: "Header font size",
          },
          {
            label: "Font Weight",
            accessAs: "header.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Header font weight",
          },
          {
            label: "Font Family",
            accessAs: "header.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Header font family",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Running Messages",
    sectionKey: "runningMessages",
    description: "Styling for the running messages section",
    groups: [
      {
        groupName: "Regular Colors",
        elements: [
          {
            label: "Text Color",
            accessAs: "runningMessages.regular.color",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Running messages text color",
            options: {
              allowInherit: true,
              modalTitle: "Running Messages Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "runningMessages.regular.background",
            component: "ColorSelector",
            default: "#334155",
            description: "Running messages background color",
            options: {
              allowInherit: true,
              modalTitle: "Running Messages Backgound Color",
            },
          },
        ],
      },
      {
        groupName: "Regular Typography",
        elements: [
          {
            label: "Font Size",
            accessAs: "runningMessages.regular.fontSize",
            component: "FontSizeSelector",
            default: "1.25rem",
            allowCustom: true,
            description: "Running messages font size",
          },
          {
            label: "Font Weight",
            accessAs: "runningMessages.regular.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Running messages font weight",
          },
          {
            label: "Font Family",
            accessAs: "runningMessages.regular.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Running messages font family",
          },
        ],
      },
      {
        groupName: "Important Colors",
        elements: [
          {
            label: "Text Color",
            accessAs: "runningMessages.important.color",
            component: "ColorSelector",
            default: "#ffffff",
            description: "Important running messages text color",
            options: {
              allowInherit: true,
              modalTitle: "Running Messages Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "runningMessages.important.background",
            component: "ColorSelector",
            default: "#334155",
            description: "Important running messages background color",
            options: {
              allowInherit: true,
              modalTitle: "Running Messages Backgound Color",
            },
          },
        ],
      },
      {
        groupName: "Important Typography",
        elements: [
          {
            label: "Font Size",
            accessAs: "runningMessages.important.fontSize",
            component: "FontSizeSelector",
            default: "1.25rem",
            allowCustom: true,
            description: "Important running messages font size",
          },
          {
            label: "Font Weight",
            accessAs: "runningMessages.important.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Important running messages font weight",
          },
          {
            label: "Font Family",
            accessAs: "runningMessages.important.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Important running messages font family",
          },
        ],
      },
    ],
  },
  {
    sectionName: "Events",
    sectionKey: "events",
    description: "Styling for event tiles and related elements",
    groups: [
      {
        groupName: "Container",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.container.color",
            component: "ColorSelector",
            default: "#1a1a1a",
            description: "Events container text color",
            options: {
              allowInherit: true,
              modalTitle: "Event Container Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.container.background",
            component: "ColorSelector",
            default: "#f8fafc",
            description: "Events container background color",
            options: {
              allowInherit: true,
              modalTitle: "Event Container Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.container.fontSize",
            component: "FontSizeSelector",
            default: "1rem",
            allowCustom: true,
            description: "Events container font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.container.fontWeight",
            component: "FontWeightSelector",
            default: "400",
            description: "Events container font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Events container font family",
          },
        ],
      },
      {
        groupName: "Title",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.title.color",
            component: "ColorSelector",
            default: "#1a1a1a",
            description: "Events container text color",
            options: {
              allowInherit: true,
              modalTitle: "Event title Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.title.fontSize",
            component: "FontSizeSelector",
            default: "1.25rem",
            allowCustom: true,
            description: "Events title font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.title.fontWeight",
            component: "FontWeightSelector",
            default: "400",
            description: "Events title font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.title.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Events title font family",
          },
        ],
      },
      {
        groupName: "Teams",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.teams.color",
            component: "ColorSelector",
            default: "#1a1a1a",
            description: "Events container text color",
            options: {
              allowInherit: true,
              modalTitle: "Event teams Text Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.teams.fontSize",
            component: "FontSizeSelector",
            default: "1.25rem",
            allowCustom: true,
            description: "Events teams font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.teams.fontWeight",
            component: "FontWeightSelector",
            default: "400",
            description: "Events teams font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.teams.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Events teams font family",
          },
        ],
      },
      {
        groupName: "Time Range Badge",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.badges.timeRange.color",
            component: "ColorSelector",
            default: "#0f172a",
            description: "Time range badge text color",
            options: {
              allowInherit: true,
              modalTitle: "Time Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.badges.timeRange.background",
            component: "ColorSelector",
            default: "#e0e7ff",
            description: "Time range badge background color",
            options: {
              allowInherit: true,
              modalTitle: "Time Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.badges.timeRange.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Time range badge font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.badges.timeRange.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Time range badge font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.badges.timeRange.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Time range badge font family",
          },
        ],
      },
      {
        groupName: "Room Badge",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.badges.room.color",
            component: "ColorSelector",
            default: "#0c4a6e",
            description: "Room badge text color",
            options: {
              allowInherit: true,
              modalTitle: "Room Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.badges.room.background",
            component: "ColorSelector",
            default: "#dbeafe",
            description: "Room badge background color",
            options: {
              allowInherit: true,
              modalTitle: "Room Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.badges.room.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Room badge font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.badges.room.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Room badge font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.badges.room.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Room badge font family",
          },
        ],
      },
      {
        groupName: "Location Badge",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.badges.location.color",
            component: "ColorSelector",
            default: "#115e59",
            description: "Location badge text color",
            options: {
              allowInherit: true,
              modalTitle: "Location Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.badges.location.background",
            component: "ColorSelector",
            default: "#ccfbf1",
            description: "Location badge background color",
            options: {
              allowInherit: true,
              modalTitle: "Location Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.badges.location.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Location badge font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.badges.location.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Location badge font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.badges.location.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Location badge font family",
          },
        ],
      },
      {
        groupName: "Recurrence Badge",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.badges.recurrence.color",
            component: "ColorSelector",
            default: "#115e59",
            description: "Recurrence badge text color",
            options: {
              allowInherit: true,
              modalTitle: "Recurrence Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.badges.recurrence.background",
            component: "ColorSelector",
            default: "#ccfbf1",
            description: "Recurrence badge background color",
            options: {
              allowInherit: true,
              modalTitle: "Recurrence Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.badges.recurrence.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Recurrence badge font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.badges.recurrence.fontWeight",
            component: "FontWeightSelector",
            default: "500",
            description: "Recurrence badge font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.badges.recurrence.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Recurrence badge font family",
          },
        ],
      },
      {
        groupName: "Starting Soon State",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.states.upcoming.color",
            component: "ColorSelector",
            default: "#92400e",
            description: "Starting soon state text color",
            options: {
              allowInherit: true,
              modalTitle: "Starting Soon Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.states.upcoming.background",
            component: "ColorSelector",
            default: "#fef3c7",
            description: "Starting soon state background color",
            options: {
              allowInherit: true,
              modalTitle: "Starting Soon Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.states.upcoming.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Starting soon state font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.states.upcoming.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Starting soon state font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.states.upcoming.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Starting soon state font family",
          },
        ],
      },
      {
        groupName: "Ongoing State",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.states.ongoing.color",
            component: "ColorSelector",
            default: "#065f46",
            description: "Ongoing state text color",
            options: {
              allowInherit: true,
              modalTitle: "Onging Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.states.ongoing.background",
            component: "ColorSelector",
            default: "#d1fae5",
            description: "Ongoing state background color",
            options: {
              allowInherit: true,
              modalTitle: "Ongoing Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.states.ongoing.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Ongoing state font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.states.ongoing.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Ongoing state font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.states.ongoing.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Ongoing state font family",
          },
        ],
      },
      {
        groupName: "Ends Soon State",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.states.ending.color",
            component: "ColorSelector",
            default: "#9a3412",
            description: "Ends soon state text color",
            options: {
              allowInherit: true,
              modalTitle: "Ends Soon Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.states.ending.background",
            component: "ColorSelector",
            default: "#fed7aa",
            description: "Ends soon state background color",
            options: {
              allowInherit: true,
              modalTitle: "Ends Soon Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.states.ending.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Ends soon state font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.states.ending.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Ends soon state font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.states.ending.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Ends soon state font family",
          },
        ],
      },
      {
        groupName: "Ended State",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.states.ended.color",
            component: "ColorSelector",
            default: "#9a3412",
            description: "Ended state text color",
            options: {
              allowInherit: true,
              modalTitle: "Ended Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.states.ended.background",
            component: "ColorSelector",
            default: "#fed7aa",
            description: "Ended state background color",
            options: {
              allowInherit: true,
              modalTitle: "Ended Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.states.ended.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Ended state font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.states.ended.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Ended state font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.states.ended.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Ended state font family",
          },
        ],
      },
      {
        groupName: "Cancelled State",
        elements: [
          {
            label: "Text Color",
            accessAs: "events.states.canceled.color",
            component: "ColorSelector",
            default: "#991b1b",
            description: "Cancelled state text color",
            options: {
              allowInherit: true,
              modalTitle: "Cancelled Badge Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "events.states.canceled.background",
            component: "ColorSelector",
            default: "#fecaca",
            description: "Cancelled state background color",
            options: {
              allowInherit: true,
              modalTitle: "Cancelled Badge Backgound Color",
            },
          },
          {
            label: "Font Size",
            accessAs: "events.states.canceled.fontSize",
            component: "FontSizeSelector",
            default: "0.875rem",
            allowCustom: true,
            description: "Cancelled state font size",
          },
          {
            label: "Font Weight",
            accessAs: "events.states.canceled.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Cancelled state font weight",
          },
          {
            label: "Font Family",
            accessAs: "events.states.canceled.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Cancelled state font family",
          },
        ],
      },
    ],
  },
  ...themeEditorUiConfigClock,
  ...themeEditorUiConfigCalendar,
  ...themeEditorUiConfigCountdown,
  ...themeEditorUiConfigCountup,
  ...themeEditorUiConfigMessage,
];
